const HAS_DISMISSED_SHEPHERD_TOOLTIP = 'HAS_DISMISSED_SHEPHERD_TOOLTIP';
export const setHasDismissedShepherdTooltip = () => {
  try {
    localStorage.setItem(HAS_DISMISSED_SHEPHERD_TOOLTIP, 'true');
  } catch (e) {
    console.error(e);
  }
};
export const getHasDismissedShepherdTooltip = () => {
  try {
    const hasDismissedShepherdTooltip = localStorage.getItem(HAS_DISMISSED_SHEPHERD_TOOLTIP);
    return hasDismissedShepherdTooltip === 'true';
  } catch (e) {
    console.error(e);
  }
  return false;
};